import React from "react";

import { useT } from "../i18n";
import { useTemplateVars } from "../i18n/vars";
import Seo from "../components/Seo";
import Reveal from "../components/motion/Reveal";
import { Section } from "../components/ui/primitives";
import PageHero from "../components/blocks/PageHero";
import HeroConsole from "../components/blocks/HeroConsole";
import ServiceDirectory from "../components/blocks/ServiceDirectory";
import StackGrid from "../components/blocks/StackGrid";
import PanelCta from "../components/blocks/PanelCta";

// Home is a directory, not a pitch. It says who we work with, shows the shape
// of what we run, then hands off to the seven service pages, each of which
// carries its own argument.

export default function HomePage() {
  const { t, tList } = useT();
  const vars = useTemplateVars();

  return (
    <>
      <Seo
        title={t("home.seoTitle", vars)}
        description={t("home.seoDescription", vars)}
      />

      <PageHero
        eyebrow={t("home.heroEyebrow", vars)}
        title={t("home.heroTagline")}
        lede={t("home.heroLede")}
        size="hero"
        cta={{ to: "/contact", label: t("home.heroCta") }}
      />

      <HeroConsole />

      <Section index="01" title={t("home.audienceTitle")}>
        <div className="flex max-w-[700px] flex-col gap-6">
          {tList("home.audienceBody").map((para, i) => (
            <Reveal key={i} delay={i * 80}>
              <p className="t-prose">{para}</p>
            </Reveal>
          ))}
        </div>
      </Section>

      <Section index="02" title={t("home.servicesTitle")} note={t("home.servicesLede")}>
        <ServiceDirectory />
      </Section>

      <section className="section section-t">
        <div className="shell flex flex-col gap-11">
          <Reveal className="flex flex-col gap-6 lg:flex-row lg:gap-20">
            <div className="lg:w-rail lg:shrink-0">
              <div className="flex flex-col gap-3.5">
                <span className="font-mono text-[12px] tracking-[1.2px] text-accent">03</span>
                <h2 className="t-rail">{t("home.stackTitle")}</h2>
              </div>
            </div>
            <p className="max-w-[520px] font-body text-[16px] leading-[1.6] text-fg-secondary sm:text-[17px]">
              {t("home.stackLede")}
            </p>
          </Reveal>

          <StackGrid />
        </div>
      </section>

      <PanelCta
        title={t("home.engagementTitle")}
        body={t("home.engagementBody")}
        cta={{ to: "/contact", label: t("home.engagementCta") }}
      />
    </>
  );
}
